import Env from 'env';
import { type User, UserManager } from 'oidc-client-ts';

class Auth {
  userManager: UserManager;

  constructor() {
    this.userManager = new UserManager(Env.sts);
  }

  public getUser(): Promise<User | null> {
    return this.userManager.getUser();
  }
  public getAccessToken(): Promise<string> {
    return this.userManager.getUser().then((x) => x?.access_token as string);
  }

  public login(): Promise<void> {
    return this.userManager.signinRedirect({
      state: window.location.href,
      extraQueryParams: { app: 'dec-admin' }
    });
  }

  public renewToken(): Promise<User | null> {
    return this.userManager.signinSilent();
  }

  public logout(): Promise<void> {
    return this.userManager.signoutRedirect();
  }
}
export default new Auth();
